export enum MainViewMode {
  Netzgrafik,
  Streckengrafik,
  OriginDestination,
}
